import * as React from "react";
import { Box, Button, Typography } from "@mui/material";

// Keeps a crashing page from taking down the whole shell.
// Layout keys it by pathname, so navigating away resets it.
export default class PageErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <Box role="alert" sx={{ p: 4, maxWidth: 560 }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Something went wrong on this page
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {this.state.error.message}
        </Typography>
        <Button variant="outlined" onClick={() => window.location.reload()}>
          Reload page
        </Button>
      </Box>
    );
  }
}
